// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"20afadc9","453":"a80ee3bf","455":"51e7d0a0"}[chunkId] + ".chunk.js";
};